
declare global {
  type Langauages = {
    [P in keyof typeof languages]?: LocaleDeclaration
  }
  type LocalizableText = {
    [P in keyof typeof languages]?: string
  }
  type LocalizableContent = string | LocalizableText
}

interface LocaleDeclaration {
  rtl?: boolean
  name: string
}

export interface Language {
  rtl?: boolean;
  name: string;
  english?: string;
  zendesk?: string;
  code?:string;
}

export const languages: Record<string, Language> = {
  "ar-SA": {
    rtl: true,
    name: "العربية",
    english: "Arabic",
    zendesk: "ar",
    code: "ar"
  },
  bn: {
    name: "বাংলা",
    english: "Bengali",
    code: "bn"
  },
  my: {
    name: "ဗမာ",
    english: "Burmese",
    code: "my"
  },
  cs: {
    name: "Čeština",
    english: "Czech",
    zendesk: "cs",
    code: "cs"
  },
  "fa-AF": {
    rtl: true,
    name: "دری",
    english: "Dari",
    code: "fa"
  },
  "en-US": {
    name: "English",
    english: "English",
    code: "en"
  },
  "fa-FA": {
    rtl: true,
    name: "فارسی",
    english: "Persian",
    zendesk: "fa",
    code: "fa"
  },
  "fr-FR": {
    name: "Français",
    english: "French",
    zendesk: "fr",
    code: "fr"
  },
  "de-DE": {
    name: "Deutsch",
    english: "German",
    zendesk: "de",
    code: "de"
  },
  el: {
    name: "Ελληνικά",
    english: "Greek",
    zendesk: "el-gr",
    code: "el"
  },
  ht: {
    name: "Kreyòl",
    english: "Haitian Creole",
    zendesk: "ht",
    code: "ht"
  },
  "fr-HT": {
    name: "Français haïtien",
    english: "French (Haiti)",
    zendesk: "fr-ht",
    code: "fr"
  },
  "ha-HA": {
    name: "Hausa",
    english: "Hausa",
    code: "ha"
  },
  "hu-HU": {
    name: "Magyar",
    english: "Hungarian",
    code: "hu"
  },
  "it-IT": {
    name: "Italiano",
    english: "Italian",
    zendesk: "it",
    code: "it"
  },
  KAU: {
    name: "Kanuri",
    english: "Kanuri",
    zendesk: "ko-kr",
    code: "kr"
  },
  "ki-KI": {
    name: "Kirundi",
    english: "Kirundi",
    zendesk: "rn-BI",
    code: "rn"
  },
  "ln-LN": {
    name: "Lingála",
    english: "Lingala",
    zendesk: "ln",
    code: "ln"
  },
  "ps-PS": {
    rtl: true,
    name: "پښتو",
    english: "Pashto (Afghanistan)",
    zendesk: "ps",
    code: "ps"
  },
  "ru-RU": {
    name: "Русский",
    english: "Russian",
    zendesk: "ru",
    code: "ru"
  },
  "so-SO": {
    name: "Soomaali",
    english: "Somali",
    zendesk: "so",
    code: "so"
  },
  "es-ES": {
    name: "Español",
    english: "Spanish",
    zendesk: "es",
    code: "es"
  },
  "sw-SW": {
    name: "Kiswahili",
    english: "Swahili",
    zendesk: "sw",
    code: "sw"
  },
  th: {
    name: "ไทย",
    english: "Thai",
    zendesk: "th",
    code: "th"
  },
  "uk-UK": {
    name: "Українська",
    english: "Ukrainian",
    zendesk: "uk",
    code: "uk"
  },
  "ur-UR": {
    rtl: true,
    name: "اردو",
    english: "Urdu",
    zendesk: "ur",
    code: "ur"
  },
  "vi-VN": {
    name: "Tiếng Việt",
    english: "Vietnamese",
    zendesk: "vi",
    code: "vi"
  },
  "ko-KR": {
    name: "한국어",
    english: "Korean",
    zendesk: "ko",
    code: "ko"
  },
  "zh-CN": {
    name: "中文",
    english: "Chinese",
    zendesk: "zh-cn",
    code: "zh"
  },
  am : {
    name: "አማርኛ",
    english: "Amharic",
    zendesk: "am",
    code: "am"
  }
};
